import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from './DataContext';
import LandingPage from './pages/LandingPage';
import LiveClassPage from './pages/LiveClassPage';
import LiveClassReportPage from './pages/LiveClassReportPage';
import PromoSchedulePage from './pages/PromoSchedulePage';
import FeedbackPage from './FeedbackPage';
import './App.css';

function App() {
  return (
    <DataProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/life-class/report" element={<Navigate to="/live-class/report" replace />} />
          <Route path="/live-class/report" element={<LiveClassReportPage />} />
          <Route path="/live-class" element={<LiveClassPage />} />
          <Route path="/life-class" element={<Navigate to="/live-class" replace />} />
          <Route path="/promo-schedule" element={<PromoSchedulePage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </DataProvider>
  );
}

export default App;
